import SelectField from "@imminently/decisively-ui/SelectField";
import { EVENT_TYPE_INFO, getEventTypeDisplayName } from "@packages/commons";

const options = [
  { value: "all", label: "All event types" },
  ...Object.values(EVENT_TYPE_INFO)
    .filter(event => event.canConnect)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((type) => ({ value: type.id, label: `${type.name} (${type.id})` })),
];

export const EventTypeFilter = ({ value, onValueChange }: {
  value: string;
  onValueChange: (value: string) => void;
}) => {
  const customOption = value && !Object.prototype.hasOwnProperty.call(EVENT_TYPE_INFO, value)
    ? [{ value, label: getEventTypeDisplayName(value) }]
    : [];
  return <SelectField
    name="event-filter-type"
    label="Event type"
    value={value || "all"}
    onValueChange={(value) => onValueChange(value === "all" ? "" : value || "")}
    options={[...options, ...customOption]}
    searchable
    fullWidth
  />;
};
